module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, _vm._l((_vm.events), function(event, index) {
    return (index <= _vm.showLimit - 1) ? _c('div', {
      staticClass: "events-container",
      class: _vm.eventClasses(event),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.eventClick(event)
        }
      }
    }, [_c('div', {
      staticClass: "day-number"
    }, [_vm._v("\n            " + _vm._s(_vm.day.monthDay) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "event"
    })]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5404d212","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/vue-calendar/events-box.vue
// module id = 1203
// module chunks = 0